import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Doctor from "@/pages/Doctor";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Diagnostics from "@/pages/Diagnostics";
import Appointment from "@/pages/Appointment";
import Teleconsultation from "@/pages/Teleconsultation";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Gallery from "@/pages/Gallery";
import Testimonials from "@/pages/Testimonials";
import FAQs from "@/pages/FAQs";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ScrollToTop from "@/components/ScrollToTop";

const Public = (El) => (
  <PublicLayout>
    <El />
  </PublicLayout>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={Public(Home)} />
          <Route path="/about" element={Public(About)} />
          <Route path="/doctor" element={Public(Doctor)} />
          <Route path="/services" element={Public(Services)} />
          <Route path="/services/:slug" element={Public(ServiceDetail)} />
          <Route path="/diagnostics" element={Public(Diagnostics)} />
          <Route path="/appointment" element={Public(Appointment)} />
          <Route path="/teleconsultation" element={Public(Teleconsultation)} />
          <Route path="/blog" element={Public(Blog)} />
          <Route path="/blog/:slug" element={Public(BlogPost)} />
          <Route path="/gallery" element={Public(Gallery)} />
          <Route path="/testimonials" element={Public(Testimonials)} />
          <Route path="/faqs" element={Public(FAQs)} />
          <Route path="/contact" element={Public(Contact)} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="*" element={Public(Home)} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
